namespace SavCommon {
    export enum ClientCustomizationType {
        ORIGINAL = 0,
        FRANZESE = 1,
    }
    export namespace Dashboard {
        export function InitComunicazioniAgenti(baseUrlFiltro: string, divTabella: string, bodyTabella: string, rigaTabella: string, loadStatusClass: string, initRowPerPage: number) {
            let filtroBase = new Controlli.UtilityTabella.BaseFiltriListaDto();
            filtroBase.PaginaAttuale = 1;
            filtroBase.RighePerPagina = initRowPerPage;
            let opzioni: BaseFiltriOptions = { baseUrlFiltro, divTabella, bodyTabella, rigaTabella, loadStatusClass };

            SetupBaseInfiniteScroll(opzioni, filtroBase)
        }
    }

    function SetupBaseInfiniteScroll(opzioni: BaseFiltriOptions, filtro: Controlli.UtilityTabella.BaseFiltriListaDto) {
        let infiniteScrollTable: JQuery<HTMLElement> = Controlli.UtilityTabella.InitInfiniteScrollPost(opzioni.bodyTabella, opzioni.baseUrlFiltro, opzioni.rigaTabella, opzioni.divTabella, opzioni.loadStatusClass, filtro);

        let infScroll = infiniteScrollTable.data('infiniteScroll');
        infiniteScrollTable.on('load.infiniteScroll', function (event, body, path, response) {
            filtro.PaginaAttuale = infScroll.pageIndex;
        });
        infiniteScrollTable.on('append.infiniteScroll', function (event, body, path, items: NodeList, response) {
            if (items.length > 0) {
                Controlli.Utility.DestroyControl(opzioni.bodyTabella);
                Controlli.Utility.RefreshControl(opzioni.bodyTabella);
            }
        });
    }

    interface BaseFiltriOptions {
        divTabella: string;
        bodyTabella: string;
        baseUrlFiltro: string;
        rigaTabella: string;
        loadStatusClass: string;
    }
}